import { TRANSFER_LIST } from '../message/actions';

export default (previousState = false, { type, payload }) => {
    if (type === TRANSFER_LIST) {
        return payload;
    }
    return previousState;
};
